<template>
  <v-row justify="center" v-if="programa">
    <v-dialog v-model="dialog" scrollable max-width="90%">
      <v-card>
        <v-card-title>Asignar Responsable al Programa</v-card-title>
        <v-divider class="ma-0"></v-divider>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12">
              <v-text-field
                autofocus
                v-model="search"
                class="ma-2"
                @input="buscar"
                label="Buscar por C.I ó Nombre"
                hint="Escriba y Seleccione el Responsable de la lista"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <!-- si existe responsable asignado mostrado aqui -->
            <v-col cols="12" class="text-center" v-if="responsable">
              <p>
                <b>Responsable Asignado: </b> {{ responsable.num_doc }} - {{ responsable.nombres }} {{ responsable.pri_apellido }}
                {{ responsable.seg_apellido }}
              </p>
            </v-col>
            <v-col cols="12" v-if="search && search.length > 3">
              <v-data-table :headers="headers" :items="teachers" sort-by="full_name">
                <template #[`item.full_name`]="{ item }">{{ item.nombres }} {{ item.pri_apellido }} {{ item.seg_apellido }}</template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" v-on="on" color="orange" @click="assignResponsibleAtProgram(item)">mdi-plus-outline</v-icon>
                    </template>
                    Asignar Como responsable de <b>{{ programa.nombre_compuesto }}</b>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cerrar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,
      search: null,
      teachers: [],
      headers: [
        // { text: 'id', value: 'id', width: 50 },
        { text: 'N° Documento', value: 'num_doc' },
        { text: 'Nombre Completo', value: 'full_name', sortable: false },
        { text: 'Correo Electronico', value: 'email', width: 120, sortable: false },
        { text: 'Opciones', value: 'actions', sortable: false },
      ],
      dialog: false,
      programa: null,
      responsable: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(programa) {
      this.dialog = true;
      this.programa = programa;
      // the next line should verify if exists assign Responsible
      // if (this.programa.responsable) this.showResponsibleAssigned(responsable);
    },
    buscar(query = null) {
      if (query && query.length > 3) {
        let isdocumento = /^\d+$/.test(+query);
        let sql = gql`query{ getPersonasByName(nombres:"${query}"){id num_doc nombres pri_apellido seg_apellido email telefono1 usuario_moodle clave_moodle } }`;
        if (isdocumento)
          sql = gql`query{ getPersonasByDoc(num_doc:"${+query}", estado:true){id num_doc nombres pri_apellido seg_apellido email telefono1 usuario_moodle clave_moodle  } }`;
        this.$apollo
          .query({ query: sql })
          .then(({ data }) => (this.teachers = data && data.getPersonasByName ? data.getPersonasByName : data.getPersonasByDoc));
      }
    },

    assignResponsibleAtProgram(usuario) {
      this.$root.$confirm.open('Asignar Responsable', 'Estas seguro de asignar?', { color: 'orange' }).then((confirm) => {
        if (this.programa && usuario && confirm) {
          const url = `${this.api_rest}/esam/programa/responsable`;
          let userForm = { responsable_id: usuario.id, programa_id: this.programa.id };
          window.console.log(this.programa, usuario, confirm,'/n url and form', url, userForm);
          xaxios
            .post(url, userForm)
            .then(() => {
              this.$root.$notify.show(`Responsable Asignado Exitosamente`, { color: 'success' });
              this.closeDialog();
            })
            .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'red', x: 'right' }));
        }
      });
    },
    showResponsibleAssigned(usuario) {
      this.search = usuario.num_doc;
    },

    closeDialog() {
      this.dialog = false;
      this.programa = null;
      this.search = null;
      this.responsable = false;
    },
  },
};
</script>
